import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, Input } from "@mui/material";
import { OFFER_STATUS } from "../utils/enums";
import { isNumber } from "../utils/validations";
import { UploadMedia } from "../utils/mediaUpload";

interface CommissionOfferModalProps {
  open: boolean;
  onClose: (status: number) => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  setCommission: Dispatch<SetStateAction<string>>;
  commission: string;
  selectedPrice: string;
  setPdfFile: Dispatch<SetStateAction<string>>;
  pdfFile: string;
}

export default function CommissionOfferModal({
  open,
  onClose,
  setOpen,
  commission,
  setCommission,
  selectedPrice,
  pdfFile,
  setPdfFile,
}: CommissionOfferModalProps) {
  console.log("pdfFile", pdfFile);
  const handleUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    if (!file) {
      setPdfFile("");
      return;
    }

    const imageUrl = (await UploadMedia(file)) as any;
    if (imageUrl?.data) {
      setPdfFile(imageUrl?.data || "");
    }
  };
  return (
    <Modal
      className="modal commissionOffer_modal"
      open={open}
      onClose={() => setOpen(false)}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Add Commission</h2>
            <div className="btn-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </div>
          <div className="view_page gap_p">
            <div className="w_100">
              <h6>Quoted Price</h6>
              <p className="c_primary">AED {selectedPrice || "0"}</p>
            </div>
          </div>
          <form className="form" action="">
            <div className="control_group">
              <div className="section_title">
                <h2>Commission (%)</h2>
              </div>

              <TextField
                placeholder="Enter Commission (%)"
                fullWidth
                hiddenLabel
                value={commission}
                onChange={(val) => {
                  const value = val.target.value;
                  const numberValue = Number(value);
                  if (
                    value === "" || // Allow clearing the field
                    (/^\d{1,3}$/.test(value) &&
                      numberValue >= 1 &&
                      numberValue <= 100)
                  ) {
                    setCommission(value);
                  }
                }}
                inputProps={{ inputMode: "numeric", maxLength: 3 }}
              />

              <div style={{ marginTop: 20 }}>
                <div className="section_title">
                  <h2>Admin Quotation</h2>
                </div>
                {pdfFile ? (
                  <div
                    className="abc"
                    style={{ position: "relative", marginTop: "0px" }}
                  >
                    <div className="childDiv w_100" style={{ width: "100%" }}>
                      <div className="docView docview1">
                        <a
                          style={{ width: "100%" }}
                          onClick={() => window.open(pdfFile)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <figure>
                            <img src="/static/images/pdf.png" alt="PDF Icon" />
                          </figure>
                          <div
                            style={{
                              padding: "10px 10px",
                              //  border: '1px solid black',
                              color: "black",
                              borderRadius: "10px",
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <div>
                              <p style={{ margin: 0, color: "black" }}>
                                {pdfFile?.slice(0, 40)}
                              </p>
                              <div
                                style={{
                                  marginTop: "5px",
                                  height: "1px",
                                  backgroundColor: "black",
                                  width: "100%",
                                  cursor: "pointer",
                                }}
                              />
                            </div>

                            <img
                              src="/static/images/check.png"
                              alt="PDF Icon"
                              style={{ height: "20px", width: "20px" }}
                            />
                          </div>

                          <p style={{ cursor: "pointer" }}>View</p>
                        </a>

                        {/* Move CloseIcon outside the <a> */}
                        <CloseIcon
                          onClick={(e) => {
                            e.stopPropagation();
                            setPdfFile("");
                          }}
                          style={{
                            cursor: "pointer",
                            position: "absolute",
                            top: "8px",
                            right: "8px",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    className="abc"
                    style={{ position: "relative", marginTop: "0px" }}
                  >
                    <label style={{ width: "100%" }} htmlFor="icon-button-file">
                      <Input
                        sx={{ display: "none" }}
                        id="icon-button-file"
                        type="file"
                        inputProps={{
                          accept: "application/pdf",
                          multiple: false,
                        }}
                        onChange={(e: any) => {
                          handleUpload(e);
                          e.target.value = null;
                        }}
                      />

                      <div className="docView docview1">
                        <div className="anchor" style={{ width: "100%" }}>
                          <figure>
                            <img src="/static/images/pdf.png" alt="PDF Icon" />
                          </figure>
                          <p style={{ cursor: "pointer" }}>Click to upload</p>
                        </div>
                      </div>
                    </label>
                  </div>
                )}
              </div>
            </div>
            <div className="footer_btn_flex">
              <Button className="btn btn_grey" onClick={() => setOpen(false)}>
                Cancel
              </Button>
              <Button
                className="btn btn_primary"
                onClick={() => onClose(OFFER_STATUS.ACCEPTED)}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
